import {
    Component,
    HostBinding,
    forwardRef
} from '@angular/core';
import {
    NG_VALUE_ACCESSOR,
    ControlValueAccessor,
} from '@angular/forms';

@Component({
    selector: 'app-checkbox',
    templateUrl: './checkbox.component.pug',
    styleUrls: ['./checkbox.component.less'],
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => CheckboxComponent),
        multi: true
    }]
})
export class CheckboxComponent implements ControlValueAccessor {
    @HostBinding('class.--checked') checked: boolean;

    constructor(
    ) {
    }

    onChange($event) {
        this.checked = $event.target.checked;

        this.propagateChange(this.checked);
    }

    // START: ControlValueAccessor Interface
    writeValue(value: boolean) {
        this.checked = value;
    }

    propagateChange = (_: any) => {
    }

    registerOnChange(fn) {
        this.propagateChange = fn;
    }

    registerOnTouched() {
    }
    // END: ControlValueAccessor Interface
}
